import { CGameBase, CGameState } from "./CGameBase";
import { SoundMgr } from "./SoundMgr";
import { ResourcesList } from "./ResourcesList";
import { LoadingView } from "./LoadingView";
import { CByteArray } from "./CByteArray";
import { CNetPeer } from "./CNetPeer";
import { CDefine, CEnumTypes } from "./CEnumTypes";
import { CLoginPlayer } from "./CLoginPlayer";
import { CMJGame } from "./CMJGame";
import { CMJGameTest } from "./CMJGameTest";
import { CLobbyTable } from "./CLobbyTable";
import { CConfig } from "./CConfig";
import { CPacket } from "./CPacket";
import { CMJLobby } from "./CMJLobby";
import { CMJLogin } from "./CMJLogin";

// When a function is used as a callback, this is lost.
// Sometimes the bind() method has to be used to prevent losing this.
type GameConfig = {
    musVolume: number;
    sndVolume: number;
	vocVolume: number;
	privateCheck: boolean;
}

const ShowFPS = 0;

export class CGame extends CGameBase {
	public static secs_RefreshPage:number = 10*60;

	private stats:{ update:() => void, dom:HTMLElement };
	private loadingView: LoadingView;
	public m_pUserPlayer:CLoginPlayer = new CLoginPlayer();
	public static m_instance:CGame = null;
	public m_clTable:CLobbyTable;
	private m_mcSetup:fgui.GComponent;
	private m_mcEdit:fgui.GComponent;
	private m_mcDialog:fgui.GComponent;
	private m_cbDialog:Function;
	private m_dlgClick:boolean;
	public m_tmBlur:number;
	public m_bgMode:boolean = false;
	private m_token:string;
	private CPkt:CPacket = new CPacket(256);
	private m_returnURL:string;
	public m_ReLogin:number;
	public m_connState:number;
	public m_updateWifi:boolean = false;
	public m_fgInviteGuild:number;
	public m_InviteMsg:string;
	public m_privateCheck:boolean;
	public m_fgBulletin:boolean;

	public constructor() {
		let mdScale = fgui.StageScaleMode.SHOW_ALL;
		let mdOrientation = fgui.StageOrientation.LANDSCAPE;

		super(CConfig.gameWD, CConfig.gameHT, {
			view: document.querySelector("#canvasContainer canvas") as HTMLCanvasElement,
			//backgroundColor: 0xb5b5b5,
			backgroundColor: 0,
            forceCanvas: false,
            antialias: true,
			//resolution: (window.devicePixelRatio || 1)
		})

		if( ShowFPS ) {
			this.stats = new window["Stats"]();
			document.body.appendChild(this.stats.dom);
		}
	}

	public static DebugLog( ...args ):void {
		console.log("Debug:", args.toString());
	}

	public static get Instance():CGame {
		if( this.m_instance == null ) this.m_instance = new CGame();
		return this.m_instance;
	}

	public static base64ToBytes(base64:string) {
		const binString = atob(base64);
		return Uint8Array.from(binString, (m) => m.codePointAt(0));
	}
	  
	public static bytesToBase64(bytes):string {
		const binString = Array.from(bytes, (byte:number) =>
			String.fromCodePoint(byte),
		).join("");
		return btoa(binString);
	}

	public LoadConfig():void {
		const jsonText = localStorage.getItem("gameConfig");
		if( jsonText != null ) {
			CGame.DebugLog(jsonText);
			let json = JSON.parse(jsonText);
			//if( json.Return == 1 ) {
				if( json.musVolume != undefined ) SoundMgr.musVolume = json.musVolume;
				if( json.sndVolume != undefined ) SoundMgr.sndVolume = json.sndVolume;
				if( json.vocVolume != undefined ) SoundMgr.vocVolume = json.vocVolume;
				if( json.privateCheck != undefined ) this.m_privateCheck = json.privateCheck;
			//}
		}
	}

	public SaveConfig():void {
		let gc: GameConfig = {"musVolume": SoundMgr.musVolume, "sndVolume": SoundMgr.sndVolume, "vocVolume": SoundMgr.vocVolume, "privateCheck": this.m_privateCheck};
		localStorage.setItem("gameConfig", JSON.stringify(gc));
		CGame.DebugLog("SaveConfig done ...", SoundMgr.musVolume, SoundMgr.sndVolume, SoundMgr.vocVolume, this.m_privateCheck);
	}

	private loadProgress(loader: PIXI.Loader): void {
		let p = loader.progress;
        this.loadingView.setProgress(p);
        if (p >= 100) {
            loader.onProgress.detachAll();
			fgui.GRoot.inst.removeChild(this.loadingView);
            this.loadingView.dispose();
            this.loadingView = null;
        }
    }

	private getParameter():boolean {
		const queryString = window.location.search;
		CGame.DebugLog(queryString);
		const urlParams = new URLSearchParams(queryString);
		const token = urlParams.get('token');
		if( token == undefined ) {
			alert("參數錯誤！");
			return false;
			//this.ShowDialog("", "參數錯誤！", ["確定"]);
		}
		this.m_token = token;
		return true;
	}

	private resLoaded(loader: PIXI.Loader): void {
        loader.destroy();
		ResourcesList.RES.forEach(element => {
			if( element.type == "bin" ) {
				fgui.UIPackage.addPackage(element.id);
			}
			// else if( element.type == "font" ) {
			// }
		});
		this.m_clTable = new CLobbyTable();

		// this.Login2Server();
		//window.onresize = this.onResize;
		this.ChangeState(CMJLogin.Instance);
		// this.ChangeState(CMJLobby.Instance);
		//this.ChangeState(CMJGame.Instance);
		// this.ChangeState(CMJGameTest.Instance);
	}

	public override Init(): void {
		super.Init(8192);

		CGame.DebugLog("version:"+CConfig.gameVersion);

		SoundMgr.init();

		this.m_privateCheck = false;
		this.m_fgBulletin = false;
		this.m_fgInviteGuild = 0;
		this.m_updateWifi = false;
		this.m_connState = 10;
		this.m_tmBlur = 0;
		this.m_mcSetup = null;
		this.m_mcDialog = null;
		this.m_cbDialog = null;
		this.m_dlgClick = false;

		this.LoadConfig();

		fgui.GRoot.inst.addChild(this.loadingView = new LoadingView());
		this.loadingView.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		this.loadingView.addRelation(fgui.GRoot.inst, fgui.RelationType.Size);

		let loader = new fgui.utils.AssetLoader();
		ResourcesList.RES.forEach(element => {
			if( element.type == "bin" ) {
				loader.add(element.id, element.path, { loadType: PIXI.LoaderResource.LOAD_TYPE.XHR, xhrType: PIXI.LoaderResource.XHR_RESPONSE_TYPE.BUFFER });
			}
			else if( element.type == "font" ) {
				loader.add(element.id, element.path, { loadType: PIXI.LoaderResource.LOAD_TYPE.XHR, xhrType: PIXI.LoaderResource.XHR_RESPONSE_TYPE.BUFFER });
			}
			else { //if( element.type == "image" ) {
				loader.add(element.id, element.path);
			}
		});
		loader.onProgress.add(this.loadProgress, this);
		loader.onComplete.add(this.resLoaded, this);
		loader.load();
	}

	public addTween(target:any, showtm:number, waittm:number, prop:any, ease:Function, callback:Function = null, para:number = 0):void {
		createjs.Tween.get(target)
				.wait(waittm)
				.to(prop, showtm, ease)
				.call(function() {
					if( callback != null ) callback(para);
				})
	}

	private onClickDialogButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		this.SetGObjectCallbackFunc(this.m_mcDialog, this.onClickDialogButton, false, this);
		SoundMgr.play("s002");
		this.m_dlgClick = false;
		fgui.GRoot.inst.removeChild(this.m_mcDialog);
		let result = false;
		if( btn.name == "btn_Confirm" ) {
			result = true;
		}
		if( this.m_cbDialog ) this.m_cbDialog(result);
		this.m_cbDialog = null;
	}

	public updateDialog(title:string, msg:string, cb?:Function):void {
		let dlg = fgui.GRoot.inst.getChild("mc_mainDialog") as fgui.GComponent;
		if( dlg == null || dlg == undefined ) {
			if( this.m_mcDialog == null ) {
				this.m_mcDialog = fgui.UIPackage.createObject("mjCommon", "mainDlg") as fgui.GComponent;
				this.m_mcDialog.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
				this.m_mcDialog.name = "mc_mainDialog";
			}
			dlg = this.m_mcDialog;
			fgui.GRoot.inst.addChild(this.m_mcDialog);
		}
		if( dlg ) {
			let txt = dlg.getChild("txt_Title") as fgui.GTextField;
			txt.text = title;
			txt = dlg.getChild("txt_Content") as fgui.GTextField;
			txt.text = msg;

			let c1 = dlg.getChild("btn_Confirm") as fgui.GButton;
			let c2 = dlg.getChild("btn_Cancel") as fgui.GButton;
			c1.visible = false;
			c2.visible = false;

			if( this.m_dlgClick ) this.SetGObjectCallbackFunc(this.m_mcDialog, this.onClickDialogButton, false, this);
			this.m_dlgClick = false;
			//this.m_cbDialog = cb;
			createjs.Tween.get(dlg)
					.to({y:0}, 3000, createjs.Ease.quadIn)
					.call(function(){
						fgui.GRoot.inst.removeChild(dlg);
						if( cb ) cb();
					});
		}
	}

	public HideDialog():void {
		this.SetGObjectCallbackFunc(this.m_mcDialog, this.onClickDialogButton, false, this);
		SoundMgr.play("s002");
		this.m_dlgClick = false;
		fgui.GRoot.inst.removeChild(this.m_mcDialog);
	}

	//public ShowDialog(title:string, msg:string, btnCnt:number, cb?:Function):void {
	public ShowDialog(title:string, msg:string, btnProp:Array<string>, cb?:Function):void {
		if( this.m_mcDialog == null ) {
			this.m_mcDialog = fgui.UIPackage.createObject("mjCommon", "mainDlg") as fgui.GComponent;
			this.m_mcDialog.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
			this.m_mcDialog.name = "mc_mainDialog";
		}
		this.m_mcDialog.x = 0;
		this.m_mcDialog.y = -CConfig.gameHT;
		fgui.GRoot.inst.addChild(this.m_mcDialog);

		let c1 = this.m_mcDialog.getChild("btn_Confirm") as fgui.GButton;
		let c2 = this.m_mcDialog.getChild("btn_Cancel") as fgui.GButton;
		if( btnProp.length == 0 ) {
			c1.visible = false;
			c2.visible = false;
		}
		else if( btnProp.length == 1 ) {
			c1.x = 500;
			c1.text = btnProp[0];
			c1.visible = true;
			c2.visible = false;
		}
		else {
			c1.x = 603;
			c1.visible = true;
			c2.visible = true;
			c1.text = btnProp[0];
			c2.text = btnProp[1];
		}

		this.SetGObjectCallbackFunc(this.m_mcDialog, this.onClickDialogButton, true, this);
		this.m_cbDialog = cb;
		this.m_dlgClick = true;

		SoundMgr.play("s000");
		let txt = this.m_mcDialog.getChild("txt_Title") as fgui.GTextField;
		txt.text = title;
		txt = this.m_mcDialog.getChild("txt_Content") as fgui.GTextField;
		txt.text = msg;
		createjs.Tween.get(this.m_mcDialog).to({y:0}, 200, createjs.Ease.quadIn);
	}

	private onClickSetupButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if( btn.name == "btn_Yes" ) {
			this.SetGObjectCallbackFunc(this.m_mcSetup, this.onClickSetupButton, false, this);
			// let sld = this.m_mcSetup.getChild("sld_Music") as fgui.GSlider;
			// sld.off(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
			// SoundMgr.musVolume = sld.value / 100;
			// CGame.DebugLog(sld.value);

			let sld = this.m_mcSetup.getChild("sld_Sound") as fgui.GSlider;
			sld.off(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
			SoundMgr.sndVolume = sld.value / 100;
			CGame.DebugLog(sld.value);
			
			sld = this.m_mcSetup.getChild("sld_Voice") as fgui.GSlider;
			sld.off(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
			SoundMgr.vocVolume = sld.value / 100;
			CGame.DebugLog(sld.value);

			this.SaveConfig();

			SoundMgr.play("s003");
			var that = this;
			createjs.Tween.get(this.m_mcSetup)
				.to({y:-CConfig.gameHT}, 200, createjs.Ease.quadOut)
				.call(function(){
					fgui.GRoot.inst.removeChild(that.m_mcSetup);
				});
		}
		else if( btn.name == "btn_Fullscreen" ) {
			this.toggleFullScreen();
		}
	}

	private onSliderChange(e:fgui.GSlider):void {
		let frame = 0;
		if( e.value == 0 ) frame = 0;
		else if( e.value < 40 ) frame = 1;
		else if( e.value < 80 ) frame = 2;
		else frame = 3;
		var mc:fgui.GMovieClip;
		// if( e.name == "sld_Music" ) {
		// 	if( this.m_mcSetup.y == 0 ) SoundMgr.musVolume = e.value / 100;
		// 	mc = this.m_mcSetup.getChild("mc_volMus") as fgui.GMovieClip;
		// }
		// else 
		if( e.name == "sld_Sound" ) {
			mc = this.m_mcSetup.getChild("mc_volSnd") as fgui.GMovieClip;
			if( this.m_mcSetup.y == 0 ) {
				SoundMgr.sndVolume = e.value / 100;
				SoundMgr.play("s003", false, true);
			}
		}
		else if( e.name == "sld_Voice" ) {
			mc = this.m_mcSetup.getChild("mc_volVoc") as fgui.GMovieClip;
			if( this.m_mcSetup.y == 0 ) {
				SoundMgr.vocVolume = e.value / 100;
				SoundMgr.playVoc("act00", false, true);
			}
		}
		//CGame.DebugLog("onSliderChange:"+e.name+":"+e.value+":"+frame);
		mc.frame = frame;
	}

	public ShowSetupDialog():void {
		if( this.m_mcSetup == null ) {
			this.m_mcSetup = fgui.UIPackage.createObject("mjCommon", "ComponentSetup") as fgui.GComponent;
			this.m_mcSetup.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		}
		CGame.DebugLog("Volume:", SoundMgr.musVolume, SoundMgr.sndVolume, SoundMgr.vocVolume);
		this.m_mcSetup.x = 0;
		this.m_mcSetup.y = -CConfig.gameHT;
		fgui.GRoot.inst.addChild(this.m_mcSetup);
		this.SetGObjectCallbackFunc(this.m_mcSetup, this.onClickSetupButton, true, this);
		if( CConfig.gameTarget != "H5" ) {
			let b = this.m_mcSetup.getChild("btn_Fullscreen") as fgui.GButton;
			b.visible = false;
		}
		// let sld = this.m_mcSetup.getChild("sld_Music") as fgui.GSlider;
		// sld.on(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
		// sld.value = SoundMgr.musVolume * 100;
		// this.onSliderChange(sld);

		let sld = this.m_mcSetup.getChild("sld_Sound") as fgui.GSlider;
		sld.on(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
		sld.value = SoundMgr.sndVolume * 100;
		this.onSliderChange(sld);

		sld = this.m_mcSetup.getChild("sld_Voice") as fgui.GSlider;
		sld.on(fgui.StateChangeEvent.CHANGED, this.onSliderChange, this);
		sld.value = SoundMgr.vocVolume * 100;
		this.onSliderChange(sld);
		SoundMgr.play("s000");
		createjs.Tween.get(this.m_mcSetup).to({y:0}, 200, createjs.Ease.quartIn);
	}

	private onClickEditButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		this.SetGObjectCallbackFunc(this.m_mcEdit, this.onClickEditButton, false, this);
		// SoundMgr.play("s003");
		// var that = this;
		// createjs.Tween.get(this.m_mcEdit)
		// 	.to({y:-CGame.gameHT}, 200, createjs.Ease.quadOut)
		// 	.call(function(){
		// 		fgui.GRoot.inst.removeChild(that.m_mcEdit);
		// 	});
		if( btn.name == "btn_Confirm" ) {
			let t = this.m_mcEdit.getChild("txt_Input") as fgui.GTextInput;
			if( t.text != "" ) {
				CGame.DebugLog(t.text);
				// this.LINESendMsg(CConfig.gameURL, t.text);
			}
		}
		fgui.GRoot.inst.removeChild(this.m_mcEdit);
	}

	public ShowEditDialog(title:string):void {
		if( this.m_mcEdit == null ) {
			this.m_mcEdit = fgui.UIPackage.createObject("mjCommon", "ComponentEditDlg") as fgui.GComponent;
			this.m_mcEdit.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		}
		let txt = this.m_mcEdit.getChild("txt_Title") as fgui.GTextField;
		txt.text = title;
		this.m_mcEdit.x = 0;
		this.m_mcEdit.y = 0;//-CGame.gameHT;
		fgui.GRoot.inst.addChild(this.m_mcEdit);
		let t = this.m_mcEdit.getChild("txt_Input") as fgui.GTextInput;
		t.text = "";
		t.requestFocus();
		this.SetGObjectCallbackFunc(this.m_mcEdit, this.onClickEditButton, true, this);
		// SoundMgr.play("s000");
		// var that = this;
		// createjs.Tween.get(this.m_mcEdit)
		// 			.to({y:0}, 200, createjs.Ease.quartIn)
		// 			.call(function(){
		// 			});
	}

	// public override DoFrame(): void {
	// 	super.DoFrame();
	// 	if( ShowFPS ) this.stats.update();
	// }
	public GetVersionInfo(callback:Function = null):void {
		var url:string = CConfig.webURL+"mj16/api/getserverip.asp";
		this.DoXmlHttp("GET", url, "", callback);
	}

	public Login2Server(loginType:number = CDefine.LOGIN_LINE):void {
		this.m_CPkt.WriteByte(loginType);
		var that = this;
		this.ConnectToServer(CConfig.gameServer, 0, function(res) {
			that.ShowDialog("錯誤!!", res, ["確定"], function (result) {
				CGame.DebugLog("Login2Server Error!!", result);
				// CGame.Instance.Back2Web();
				that.ChangeState(CMJLogin.Instance);
			});
		});
	}

	public Back2Web():void {
		this.ChangeState(CMJLogin.Instance);
		// // window.location.href = CConfig.webURL;
		// if( this.m_pUserPlayer.DBID > 0 )
		// 	window.location.replace(this.m_returnURL);
		// else 
		// 	window.location.replace(CConfig.webURL);
	}

	protected override ProcessNetMessage(p: CByteArray, peer: number): number {
		// if ( peer == 1 ) {
		// 	CMJGame.Instance.ProcessMessage(p);
		// 	return 1;
		// }
		var ret:number = 1;
		p.resetPosition();
		var subType:number;
		var type:number = p.readByte();
		if( type == CNetPeer.ID_MSG_CONNECTION_ACCEPTED ) {
			CGame.DebugLog("ID_MSG_CONNECTION_ACCEPTED:" + this.m_netPeer[peer].PacketListSize());
			// this.resetPacket();
			// this.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GLOBAL_LOGIN);
			// this.m_CPkt.WriteInt(CConfig.gameVersion);
			// this.m_CPkt.WriteInt(this.m_token.length+1);
			// this.m_CPkt.WriteUTFBytes(this.m_token, this.m_token.length+1);
			this.SendData(this.m_CPkt);
		}
		else if( type == CEnumTypes.ID_MSG_GLOBAL_LOGIN ) {
			var res:number = p.readInt();
			if( res <= 0 ) {
				var errMsg:string = p.readUTFBytes(128);
				CGame.DebugLog("Error:" + errMsg);
				ret = CGameBase.ERR_DISCONNECT;
				this.ShowDialog("錯誤!!", errMsg, ["確定"], function (result) {
					CGame.DebugLog(result);
					CMJLogin.Instance.EnableButtons(true);
				});
			}
			else {
				var tPlayers:number = p.readInt();
				p.readBytes(this.m_pUserPlayer.getData(), 0, CLoginPlayer.DATA_SIZE);
				if( this.m_fgInviteGuild )
					this.m_InviteMsg = p.readUTFBytes(128);
				CGame.DebugLog("DBID: " + this.m_pUserPlayer.DBID);
				CGame.DebugLog("Gold: " + this.m_pUserPlayer.RoomCards);
				CGame.DebugLog("openid: " + this.m_pUserPlayer.openid);
				CGame.DebugLog("ip: " + this.m_pUserPlayer.IP);
				CGame.DebugLog("name: " + this.m_pUserPlayer.socialName);
				CGame.DebugLog("avatar: " + this.m_pUserPlayer.pictureURL);
				CGame.DebugLog("Login msg:" + this.m_InviteMsg);
				// this.m_LobbyState = new CMJLobby();
				// this.ChangeState(this.m_LobbyState);
				this.ChangeState(CMJLobby.Instance);
			}
		}
		else if( type == CEnumTypes.ID_MSG_LOBBY_SESSION ) {
			subType = p.readByte();
			ret = CMJLobby.Instance.ProcessMessage(subType, p);
		}
		else if( type == CEnumTypes.ID_MSG_GAME_SESSION ) {
			//subType = p.readByte();
			ret = CMJGame.Instance.ProcessMessage(p);
		}
		else if( type == CNetPeer.ID_MSG_PING2CLIENT ) {
			let tmp = p.readDWord();
			this.m_connState = p.readByte();
			CGame.DebugLog("PING: ", tmp, this.m_connState);
			this.CPkt.resetP();
			this.CPkt.WriteByte(CNetPeer.ID_MSG_PING_REPLY);
			this.CPkt.WriteDWord(tmp);
			this.SendData(this.CPkt);
			if( this.m_updateWifi ) {
				CMJGame.Instance.updateWifiStatus();
			}
		}
		else if( type == CNetPeer.ID_MSG_ECHO ) {
			let tmp = p.readDWord();
			let msg = p.readUTFBytes(27);
			CGame.DebugLog("ID_MSG_ECHO: ", tmp, msg);
		}
		return ret;
	}
}

CGame.m_instance = new CGame();

var tcount = 0;
var manualUpdateInterval = 0;
var ticker = fgui.GTimer.inst.ticker;

function BackgroundUpdate(fdelay:number, Count:number, repeat:number = 1) {
	console.log("**************** activate !!!");
	tcount = 0;
	manualUpdateInterval = setInterval(() => {
		tcount ++;
		if( tcount >= Count ) {
			tcount = 0;
			console.log("**************** BGMODE !!!");
		}
		for( var i = 0; i < repeat; i ++ ) {
			ticker.update();
			CGame.Instance.render();
		}
	}, fdelay);
}

function ResetUpdate() {
	console.log("**************** deactivate !!!");
	CGame.Instance.m_tmBlur = 0;
	if( manualUpdateInterval != 0 ) clearInterval(manualUpdateInterval); 
	manualUpdateInterval = 0;
}

// window.onblur = () => {
// 	BackgroundUpdate(66, 150);
// }
// window.onfocus = () => {
// 	ResetUpdate();
// }

document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
        console.log('網頁已進入背景或被隱藏');
        // 在此執行您的動作，例如暫停影片、停止計時器或記錄狀態
		BackgroundUpdate(66, 150);
    } else if (document.visibilityState === 'visible') {
        console.log('網頁回到前景');
        // 在此恢復動作
		ResetUpdate();
    }
});

// window.onbeforeunload = function(e){
// 	CGame.Instance.DisconnectServer();
// };
// window.onunload=function(){
// 	CGame.Instance.DisconnectServer();
// };

// document.addEventListener("visibilitychange", function() {
//     if (document.hidden && CGame.Instance.m_isLineApp ) {
//         console.log("LINE 內建瀏覽器被關閉或切換到背景");
//         // 執行關閉後的邏輯
// 		CGame.Instance.DisconnectServer();
//     }
// });